import styled from 'styled-components';

export const MainNav = {
    Container: styled.div`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #e0e0e0;
    `,
    Title: styled.div`
        font-size: 18px;
        font-weight: 600;
    `,
    Setting: styled.div`
        button{
            font-weight: 800;
            border-radius: 5px;
            padding: 0 10px;
        }
    `,
}

export const SubNav = {
    Container: styled.div`
        width: 100%;
        border-bottom: 1px solid #e0e0e0;
    `,
    TabList: styled.div`
        overflow-x: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 10px;
        @media all and (max-width:992px){
            justify-content: flex-start;
        }

        button{
            min-width: 120px;
            max-width: 120px;
            border: 1px solid #00000000;
            color:#808080;

            &.active{
                color:#000;
                border: 1px solid #000;
            }
        }
    `,
}

export const ApiSettingModal = {
    Container: styled.div`
        padding: 20px;
    `,
    Body: styled.div`
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
}